import { render, staticRenderFns } from "./ReportTreasuriesTransactions.vue?vue&type=template&id=4972b9d5&"
import script from "./ReportTreasuriesTransactions.vue?vue&type=script&lang=js&"
export * from "./ReportTreasuriesTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports